/**
 * Standard error handler for API communication errors
 * Provides consistent error handling and user messaging
 */
export const handleAPIError = (error, setMessages, setThreadId, setIsSending) => {
  console.error("API Error:", error);
  
  // For assistant not found errors
  if (error.message && error.message.includes("No assistant found")) {
    console.log("Assistant not found error, resetting thread");
    setThreadId(null); // Reset thread ID to force new thread creation
    
    // Extract the assistant ID from error message
    const assistantIdMatch = error.message.match(/'([^']+)'/);
    const problematicAssistantId = assistantIdMatch ? assistantIdMatch[1] : 'unknown';
    
    setMessages(prevMessages => [
      ...prevMessages, 
      { 
        sender: 'assistant', 
        text: `Error: The selected resource (${problematicAssistantId}) is not available. Please try a different resource or try again later.` 
      }
    ]);
  } 
  // For thread-related errors
  else if (error.message && error.message.includes("thread")) {
    console.log("Thread error detected, resetting thread");
    setThreadId(null);
    
    setMessages(prevMessages => [
      ...prevMessages, 
      { 
        sender: 'assistant', 
        text: `Error with the conversation thread. Starting a new conversation. Please try again.` 
      }
    ]);
  }
  // For permission or authentication errors
  else if (error.message && (error.message.includes("permission") || error.message.includes("authorize"))) {
    setMessages(prevMessages => [
      ...prevMessages, 
      { 
        sender: 'assistant', 
        text: `Authentication error. Please try a different resource or try again later.` 
      }
    ]);
  }
  // For all other errors
  else {
    setMessages(prevMessages => [
      ...prevMessages, 
      { 
        sender: 'assistant', 
        text: `Error communicating with the assistant: ${error.message}. Please try again.` 
      }
    ]);
  }
  
  setIsSending(false);
}; 